import PartnershipMember from "@/modules/partnership/components/PartnershipMember";
import PartnershipOwner from "@/modules/partnership/components/PartnershipOwner";
import PartnershipProgram from "@/modules/partnership/components/PartnershipProgram";

import PartnershipMemberForm from "@/modules/partnership/components/PartnershipMemberForm";
import PartnershipOwnerForm from "@/modules/partnership/components/PartnershipOwnerForm";
import PartnershipProgramForm from "@/modules/partnership/components/PartnershipProgramForm";

import PartnershipMemberDetail from "@/modules/partnership/components/PartnershipMemberDetail";

export default [
    {
        path: "/partnership-member",
        name: "PartnershipMember",
        component: PartnershipMember,
    },
    {
        path: "/partnership-owner",
        name: "PartnershipOwner",
        component: PartnershipOwner,
    },
    {
        path: "/partnership-program",
        name: "PartnershipProgram",
        component: PartnershipProgram,
    },
    {
        path: "/partnership-member-form",
        name: "PartnershipMemberForm",
        component: PartnershipMemberForm,
    },
    {
        path: "/partnership-owner-form",
        name: "PartnershipOwnerForm",
        component: PartnershipOwnerForm,
    },
    {
        path: "/partnership-program-form",
        name: "PartnershipProgramForm",
        component: PartnershipProgramForm,
    },
    {
        path: "/partnership-member-detail",
        name: "PartnershipMemberDetail",
        component: PartnershipMemberDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/partnership/router/partnership.js